/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {
	icon_info_pressed_img,
	ICONS
} from "@res/icons";
import {COLORS} from "@res/colors";


type Props = {
	onMouseOver: React.MouseEventHandler
	onMouseLeave: React.MouseEventHandler
}

type State = {
	hovered: boolean
}

export class IconInfo
	extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			hovered: false
		};
	}

	render() {
		return <div
			style={{lineHeight: 0}}
			onMouseOver={(e) => {
				this.setState({hovered: true});
				this.props.onMouseOver(e)
			}}
			onMouseLeave={(e) => {
				this.setState({hovered: false});
				this.props.onMouseLeave(e)
			}}>
			<div className={"ll_h_c"} style={{width: 16, ...!this.state.hovered && {display: "none"}}}>
				<img src={icon_info_pressed_img} alt={"info-pressed"} height={"100%"}/>
			</div>
			<div className={"ll_h_c"} style={{...this.state.hovered && {display: "none"}}}>
				{ICONS.icon_info(COLORS.neutral_text_dark_2, 16)}
			</div>
		</div>;
	}
}
